class LaborDayBanner {
  constructor() {
    this.STORAGE_KEY = "laborDayBannerTimer";
    this.SALE_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
    this.timerInterval = null;
    this.translations = window.promotionalBannerTranslations || {};
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.setupBanner());
    } else {
      this.setupBanner();
    }
  }

  setupBanner() {
    const bannerContainer = document.getElementById("labor-day-banner");
    if (!bannerContainer) {
      console.warn(
        'Labor Day Banner: Container with id "labor-day-banner" not found'
      );
      return;
    }

    this.createBannerHTML(bannerContainer);
    this.loadStyles();
    this.setupCopyFunctionality();
    this.startTimer();
  }

  createBannerHTML(container) {
    const bannerHTML = `
                <div class="labor-day-banner-wrapper">
                    <div class="labor-day-banner-background">
                        <div class="labor-day-banner-content">
                            <div class="banner-left-section">
                                <!-- <h1 class="banner-title">${
                                  this.translations.title ||
                                  "BLACK FRIDAY DISCOUNT"
                                }</h1> -->
                                <img src="https://cdn.shopify.com/s/files/1/0939/1200/6974/files/cr-sale.webp?v=1765195066" alt="Christmas Banner" class="banner-title-image"  />
                                <p class="timer-display mobile-timer" id="timer-mobile">23:22:12</p>
                            </div>
                            
                            <div class="banner-center-section">
                                <div class="labor-circle-container">
                                    <div class="savings-container">
                                        <p class="save-text">${
                                          this.translations.save_up_to ||
                                          "SAVE UP TO"
                                        }</p>
                                        <p class="percentage">${
                                          this.translations.percentage || "60%"
                                        }</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="banner-right-section">
                                <p class="timer-display" id="timer">23:22:12</p>
                                <div class="mobile-savings-section">
                                    <div class="labor-circle-container mobile-circle">
                                        <div class="savings-container">
                                            <p class="save-text">${
                                              this.translations.save_up_to ||
                                              "SAVE UP TO"
                                            }</p>
                                            <p class="percentage">${
                                              this.translations.percentage ||
                                              "60%"
                                            }</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            `;

    container.innerHTML = bannerHTML;
  }

  loadStyles() {
    // Check if styles are already loaded
    if (document.querySelector("#labor-day-banner-styles")) {
      return;
    }

    const style = document.createElement("style");
    style.id = "labor-day-banner-styles";
    style.textContent = `
                .labor-day-banner-wrapper {
                    position: relative;
                    width: 100%;
                    height: 90px;
                    font-family: 'Montserrat', sans-serif;
                    z-index:9999;
                }
    
                .labor-day-banner-background {
                    width: 100%;
                    height: 100%;
                    background-image: url('https://cdn.shopify.com/s/files/1/0939/1200/6974/files/banner-bg.avif?v=1765195065');
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    position: relative;
                    overflow: hidden;
                }
    
                /* Mobile background */
                @media (max-width: 768px) {
                    .labor-day-banner-background {
                        background-position:center;
                    }
                }
    
                .labor-day-banner-content {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 20px;
                    position: relative;
                    z-index: 2;
                    gap:5%;
                }
    
                .banner-left-section {
                    display: flex;
                    align-items: start;
                    flex-direction:column;
                    flex: 0 0 auto;
                    padding-left: 40px;
                }
    
                .banner-center-section {
                    position:relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                }
    
                .labor-circle-container {
                    position: relative;
                    width: 170px;
                    height: 140px;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-position: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 4px solid rgb(255, 255, 255);
                    border-radius: 50%;
                    background-color:white;
                }
    
                .wrench-icon {
                    width: 20px;
                    height: 20px;
                    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));
                    flex-shrink: 0;
                    position: absolute;
                    top: 2;
                    left:-30px;
                    z-index:20;
                }
    
                .savings-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }
    
                .timer-display {
                    font-size: 24px;
                    font-weight: 700;
                    color: white;
                    font-family: 'Montserrat', sans-serif;
                    width: 130px;
                    text-align: center;
                }
    
                .mobile-timer {
                    display: none;
                }
    
                .mobile-savings-section {
                    display: none;
                }
    
                .banner-title {
                    font-size: 30px;
                    font-weight: 700;
                    color: white;
                    margin: 0;
                    font-family: 'Montserrat', sans-serif;
                }
    
                .banner-right-section {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    flex: 0 0 auto;
                    padding-right: 40px;
                    gap: 8px;
                }
    
                .wrench-icon {
                    width: 50px;
                    left:-20px;
                    height: auto;
                    filter: drop-shadow(0 4px 8px rgba(0,0,0,0.3));
                }
                    .banner-title-image {
                        height: 40px;
                    }
                    @media (max-width: 768px) {
                        .banner-title-image {
                            height: 25px;
                            margin-bottom: 5px;
                        }
                    }
    
                .save-text {
                    font-size: 14px;
                    font-weight: 700;
                    color: #ff314f;
                    font-family: 'Montserrat', sans-serif;
                    text-align: center;
                    margin: 0;
                }
    
                .percentage {
                    font-size: 50px;
                    font-weight: 700;
                    color: #ff314f;
                    font-family: 'Montserrat', sans-serif;
                    text-align: center;
                    margin: 0;
                    line-height: 1;
                }
    
                /* Responsive Design */
                @media (max-width: 768px) {
                    .labor-day-banner-wrapper {
                        height: 100px;
                    }
    
                    .labor-day-banner-content {
                        justify-content: space-between;
                        padding: 0 20px;
                    }
    
                    .banner-left-section {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        padding-left: 0;
                        width: 60%;
                    }
    
                    .banner-center-section {
                        display: none;
                        position:relative;
                    }
    
                    .banner-right-section {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: flex-end;
                        padding-right: 0;
                        gap: 3px;
                    }
    
                    .banner-title {
                        font-size: 18px;
                        margin: 0 0 2px 0;
                    }
    
                    .timer-display {
                        display: none;
                    }
    
                    .mobile-timer {
                        display: block;
                        font-size: 16px;
                        width: auto;
                        text-align: left;
                        margin: 0;
                    }
    
                    .mobile-savings-section {
                        display: flex;
                        align-items: center;
                        gap: 3px;
                        position:relative
                    }
    
                    .mobile-circle {
                        width: 120px;
                        height: 120px;
                    }
    
                    .mobile-wrench {
                        width: 50px;
                        height: auto;
                        filter: drop-shadow(0 4px 8px rgba(0,0,0,0.3));
                        left: -20px;
                    }
    
                    .percentage {
                        font-size: 25px;
                    }
    
                    .save-text {
                        font-size: 8px;
                    }
                }
    
                /* Coupon Code Styling */
                .coupon-code {
                    background-color: #ff8c00;
                    padding: 6px 12px;
                    margin-top:3px;
                    margin-bottom:3px;
                    border-radius: 6px;
                    cursor: pointer;
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    transition: all 0.3s ease;
                    user-select: none;
                    position: relative;
                    overflow: hidden;
                    border: 2px solid transparent;
                }
    
                .coupon-code:hover {
                    background-color: #ff7a00;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(255, 140, 0, 0.4);
                    border-color: rgba(255, 255, 255, 0.3);
                }
    
                .coupon-code:active {
                    transform: translateY(0);
                    box-shadow: 0 2px 6px rgba(255, 140, 0, 0.3);
                }
    
                .copy-icon {
                    transition: transform 0.2s ease;
                    flex-shrink: 0;
                }
    
                .coupon-code:hover .copy-icon {
                    transform: scale(1.1);
                }
    
                .code-text {
                    font-weight: 700;
                    font-size: 14px;
                    letter-spacing: 0.5px;
                }
    
                /* Success feedback animation */
                .coupon-code.copied {
                    background-color: #10b981;
                    animation: pulse-success 0.6s ease;
                }
    
                @keyframes pulse-success {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.05); box-shadow: 0 0 20px rgba(16, 185, 129, 0.6); }
                    100% { transform: scale(1); }
                }
    
                /* Copy feedback tooltip */
                .copy-feedback {
                    position: absolute;
                    top: -35px;
                    left: 50%;
                    transform: translateX(-50%);
                    background: rgba(0, 0, 0, 0.8);
                    color: white;
                    padding: 4px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                    white-space: nowrap;
                    opacity: 0;
                    animation: fade-in-out 2s ease;
                    pointer-events: none;
                    z-index: 1000;
                }
    
                @keyframes fade-in-out {
                    0% { opacity: 0; transform: translateX(-50%) translateY(5px); }
                    20% { opacity: 1; transform: translateX(-50%) translateY(0); }
                    80% { opacity: 1; transform: translateX(-50%) translateY(0); }
                    100% { opacity: 0; transform: translateX(-50%) translateY(-5px); }
                }
    
                @media (max-width: 480px) {
                    .labor-day-banner-wrapper {
                        height: 80px;
                    }
    
                    .banner-left-section {
                        padding-left: 15px;
                    }
    
                    .banner-right-section {
                        padding-right: 15px;
                        gap: 4px;
                    }
    
                    .banner-title {
                        font-size: 14px;
                    }
    
                    .timer-display {
                        font-size: 14px;
                        width: 80px;
                    }
    
                    .percentage {
                        font-size: 35px;
                    }
    
                    .save-text {
                        font-size: 10px;
                    }
    
                    .wrench-icon {
                        width: 35px;
                    }
    
                    .coupon-code {
                        padding: 3px 6px;
                        font-size: 11px;
                        gap: 4px;
                        flex-shrink: 0;
                    }
    
                    .code-text {
                        font-size: 11px;
                        white-space: nowrap;
                    }
    
                    .copy-icon {
                        width: 12px;
                        height: 12px;
                        flex-shrink: 0;
                    }
    
                    .copy-feedback {
                        font-size: 10px;
                        top: -30px;
                    }
    
                    .banner-left-section p {
                        font-size: 12px;
                        line-height: 1.2;
                        margin-bottom: 2px;
                    }
                }
    
            `;

    document.head.appendChild(style);
  }

  setupCopyFunctionality() {
    const couponElement = document.getElementById("coupon-code");
    if (!couponElement) return;

    couponElement.addEventListener("click", async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const code = couponElement.getAttribute("data-code");
      const success = await this.copyToClipboard(code);

      if (success) {
        this.showCopyFeedback(
          couponElement,
          this.translations.copy_success || "Copied!"
        );
        this.animateCopySuccess(couponElement);
      } else {
        this.showCopyFeedback(
          couponElement,
          this.translations.copy_failed || "Failed to copy"
        );
      }
    });
  }

  async copyToClipboard(text) {
    try {
      // Modern clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }

      // Fallback for older browsers or non-secure contexts
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      textArea.style.left = "-9999px";
      textArea.style.top = "-9999px";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const result = document.execCommand("copy");
      document.body.removeChild(textArea);

      return result;
    } catch (err) {
      console.warn("Failed to copy to clipboard:", err);
      return false;
    }
  }

  showCopyFeedback(element, message) {
    // Remove any existing feedback
    const existingFeedback = element.querySelector(".copy-feedback");
    if (existingFeedback) {
      existingFeedback.remove();
    }

    // Create and show new feedback
    const feedback = document.createElement("div");
    feedback.className = "copy-feedback";
    feedback.textContent = message;
    element.appendChild(feedback);

    // Remove feedback after animation
    setTimeout(() => {
      if (feedback.parentNode) {
        feedback.remove();
      }
    }, 2000);
  }

  animateCopySuccess(element) {
    // Add success class for animation
    element.classList.add("copied");

    // Reset after animation
    setTimeout(() => {
      element.classList.remove("copied");
    }, 600);
  }

  getStoredEndTime() {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (stored) {
      const endTime = parseInt(stored, 10);
      if (endTime > Date.now()) {
        return endTime;
      }
    }
    return null;
  }

  setStoredEndTime(endTime) {
    localStorage.setItem(this.STORAGE_KEY, endTime.toString());
  }

  startTimer() {
    let endTime = this.getStoredEndTime();

    if (!endTime) {
      // Create new 24-hour timer
      endTime = Date.now() + this.SALE_DURATION;
      this.setStoredEndTime(endTime);
    }

    this.updateDisplay(endTime);

    // Update every second
    this.timerInterval = setInterval(() => {
      const now = Date.now();

      if (now >= endTime) {
        // Timer expired, restart for another 24 hours
        endTime = Date.now() + this.SALE_DURATION;
        this.setStoredEndTime(endTime);
      }

      this.updateDisplay(endTime);
    }, 1000);
  }

  updateDisplay(endTime) {
    const now = Date.now();
    const timeLeft = endTime - now;

    const hours = Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

    const timerElement = document.getElementById("timer");
    const mobileTimerElement = document.getElementById("timer-mobile");

    if (timerElement) {
      timerElement.textContent = formattedTime;
    }
    if (mobileTimerElement) {
      mobileTimerElement.textContent = formattedTime;
    }
  }

  destroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }

    const bannerElement = document.querySelector(".labor-day-banner-wrapper");
    if (bannerElement) {
      bannerElement.remove();
    }

    const styleElement = document.querySelector("#labor-day-banner-styles");
    if (styleElement) {
      styleElement.remove();
    }

    // Remove body padding
    document.body.style.paddingTop = "";
  }
}

// Auto-initialize when script loads
window.LaborDayBanner = LaborDayBanner;

// Initialize immediately if DOM is ready, otherwise wait for DOMContentLoaded
(function () {
  function initBanner() {
    if (document.getElementById("labor-day-banner")) {
      new LaborDayBanner();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBanner);
  } else {
    initBanner();
  }
})();

// For manual initialization if needed
window.initLaborDayBanner = function () {
  return new LaborDayBanner();
};
